import { OFFERINGS_SECTION_FORM_KEYS } from "../../../sidebar.constant";
import { ABOUT_YOU_CONFIG } from "ui/pages/TemplatePreview/constants.js";
import { ABOUT_YOU_MESSAGES } from "../../../sidebar.constant";

export const useOfferingsSectionHandlers = ({
  setField,
  set_section_name,
  nav_section_name,
  set_nav_section_name,
  updateData,
  set_error_object,
}) => {
  const handleSectionNameChange = (e) => {
    const value = e.target.value;
    set_section_name(value);
    setField(OFFERINGS_SECTION_FORM_KEYS.section_name.field, value);
  };

  const handleNavSectionNameChange = (e) => {
    const value = e.target.value || "";
    set_nav_section_name(value);
    setField(OFFERINGS_SECTION_FORM_KEYS.nav_section_name.field, value);

    if (value.length >= ABOUT_YOU_CONFIG.MAX_NAVBAR_TITLE_LENGTH) {
      set_error_object((prev) => ({
        ...prev,
        nav_section_name: `${ABOUT_YOU_MESSAGES.NAVBAR_TITLE_MAX} ${ABOUT_YOU_CONFIG.MAX_NAVBAR_TITLE_LENGTH} ${ABOUT_YOU_MESSAGES.CHARACTERS}`,
      }));
      return;
    }
    set_error_object((prev) => ({
      ...prev,
      nav_section_name: null,
    }));
  };

  const handleNavSectionNameBlur = () => {
    if (nav_section_name) {
      const trimmedValue = nav_section_name.trim();
      set_nav_section_name(trimmedValue);
      setField(
        OFFERINGS_SECTION_FORM_KEYS.nav_section_name.field,
        trimmedValue
      );
    }
  };

  const handleHeadingChange = (e) => {
    const value = e.target.value;
    updateData(value, OFFERINGS_SECTION_FORM_KEYS.heading.key);
  };

  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    updateData(value, OFFERINGS_SECTION_FORM_KEYS.description.key);
  };

  return {
    handleSectionNameChange,
    handleNavSectionNameChange,
    handleNavSectionNameBlur,
    handleHeadingChange,
    handleDescriptionChange,
  };
};
